/**
 * Determines the correct API endpoint based on the current deployment environment
 * @returns {string} The API base URL
 */
export const getApiBaseUrl = () => {
  // Check if we're running on the staging domain
  if (typeof window !== 'undefined' && window.location.hostname === 'nft-staging.sogni.ai') {
    return 'https://nft-api-staging.sogni.ai';
  }
  
  // Fall back to the environment variable for other deployments
  return process.env.REACT_APP_API_BASE_URL || 'https://nft-api.sogni.ai';
};

/**
 * Gets the Sogni API endpoint (different from the NFT API)
 * @returns {string} The Sogni API endpoint
 */
export const getSogniApiEndpoint = () => {
  // For now, keep using the environment variable
  // Update this if staging needs a different Sogni API endpoint
  return process.env.REACT_APP_SOGNI_API_ENDPOINT || 'https://api.sogni.ai';
};